import { useTranslation } from 'next-i18next';
import React from 'react';
import { Icon } from '@hotelplan/components.common.icon';
import { formatPrice } from '@hotelplan/fdr.lib.format.format-price';
import { FdrWishlistItemFragment } from 'fdr/schemas/fragment/wishlist/fdr-wishlist.generated';
import {
  PriceButtonWrapper,
  PriceWrapper,
} from './fdr-wishlist-compare-items-mobile.styles';

export const FdrWishlistCompareItemsMobilePriceButton: React.FC<{
  item: FdrWishlistItemFragment;
  onCheckout: (FdrWishlistItemFragment) => void;
}> = ({ item, onCheckout }) => {
  const [t] = useTranslation(['common']);

  if (!item?.trackedOffer.latest) return null;

  return (
    <PriceButtonWrapper onClick={() => onCheckout(item)}>
      <div className="price-wrap">
        <PriceWrapper>
          {t('common:perPerson.from')}
          <div className="price">
            {formatPrice(item.trackedOffer.latest.pricePerPerson)}
          </div>
        </PriceWrapper>
        <PriceWrapper>
          {t('common:totalPrice.from')}
          <div className="price">
            {formatPrice(item.trackedOffer.latest.priceTotal)}
          </div>
        </PriceWrapper>
      </div>
      <Icon name="chevron-left" className="price-button-icon" />
    </PriceButtonWrapper>
  );
};
